import React from 'react';
import Country from '../Country';
import { Subregion, SubregionBox, SubregionTitle } from '../CountrySelector/styles';
import {
  AccordionContainer,
  AccordionBox,
  AccordionTitle,
  AccordionAngle,
  AccordionContent,
} from './styles';

const CountryAccordion = ({
  regions,
  setSelectedAccordionIndex,
  selectedAccordionIndex,
  selectedCountryIndex,
  toggleDropdown,
  handleMenuVisibility,
  dropdownOpen,
  currentCountry,
}) => {
  return (
    <AccordionContainer>
      {regions &&
        regions.map((region, index) => (
          <AccordionBox key={index} active={index === parseInt(selectedAccordionIndex) && true}>
            <AccordionTitle
              onClick={() => {
                setSelectedAccordionIndex(parseInt(selectedAccordionIndex) !== index && index);
              }}
            >
              <AccordionAngle
                className={`dds__icons${
                  index === parseInt(selectedAccordionIndex) ? ' active' : ''
                }`}
              >
                〉
              </AccordionAngle>
              {region.title}
            </AccordionTitle>
            <AccordionContent
              className={index === parseInt(selectedAccordionIndex) ? ' active' : ''}
            >
              {region.subregions.map((subregion, sbIndex) => (
                <Subregion key={sbIndex}>
                  <SubregionTitle>{subregion.title}</SubregionTitle>
                  <SubregionBox data-id="subregion-box">
                    {subregion.countries.map((countryItem, ciIndex) => (
                      <Country
                        key={ciIndex}
                        country={countryItem}
                        index={ciIndex}
                        regionIndex={index}
                        selectedRegionIndex={parseInt(selectedAccordionIndex)}
                        dropdownOpen={dropdownOpen}
                        selectedCountryIndex={selectedCountryIndex}
                        handleDropdownToggle={toggleDropdown}
                        handleMenuVisibility={handleMenuVisibility}
                        currentCountry={currentCountry}
                      />
                    ))}
                  </SubregionBox>
                </Subregion>
              ))}
            </AccordionContent>
          </AccordionBox>
        ))}
    </AccordionContainer>
  );
};

export default CountryAccordion;
